@let departureAirport = data?.flightItineraries?.[0]?.departureAirport?.cityName;
@let arrivalAirport = data?.flightItineraries?.[0]?.arrivalAirport?.cityName;
@let tickets = data?.eTickets; @let registrationNumbers = data?.airlineConfirmations;

<div class="booking-trip">
  <div class="d-flex flex-column booking-trip-header">
    <div class="d-flex align-items-center booking-trip-header-title">
      <ds-button
        (click)="goBack()"
        variant="icon"
        icon="chevronLeft"
        label="Back"
        data-id="back"
        class="d-none d-md-inline"
      />
      <ds-button
        (click)="goBack()"
        variant="icon"
        icon="chevronLeft"
        label="Back"
        size="s"
        data-id="back"
        class="d-md-none"
      />

      <lead-details-title [type]="data?.tripType" [from]="departureAirport" [to]="arrivalAirport" />

      <ds-chip [title]="'Booking: ' + data?.portalLink" />
    </div>

    @if (registrationNumbers?.length) {
      <div class="d-flex flex-column g-2">
        @for (registrationNumber of registrationNumbers; track registrationNumber) {
          <div class="d-flex booking-trip-header-subtitle">
            <div class="d-flex align-items-center g-2">
              <p class="booking-trip-header-subtitle-text">Confirmation number:</p>
              <p class="booking-trip-header-subtitle-text" data-id="confirmation-title">
                {{ registrationNumber.airline?.shortName }}
              </p>

              <div
                [copyToClipboard]="registrationNumber.code"
                data-id="copy"
                class="d-flex align-items-center g-2 cursor-pointer"
              >
                <p
                  class="booking-trip-header-subtitle-text semi-bold"
                  data-id="confirmation-number"
                >
                  {{ registrationNumber.code }}
                </p>
                <img
                  class="booking-trip-header-subtitle-img"
                  src="assets/icons/copy_icon.svg"
                  alt="copy"
                />
              </div>
            </div>

            @if (registrationNumber.airline?.webSite) {
              <a
                [href]="registrationNumber.airline?.webSite"
                target="_blank"
                class="cursor-pointer link"
                data-id="airline-website"
              >
                <div class="d-flex align-items-center g-2">
                  <p class="semi-bold text-lightblue-600 booking-trip-header-subtitle-text">
                    Go to airline's website
                  </p>
                  <img
                    class="booking-trip-header-subtitle-img"
                    src="assets/icons/arrow_outward.svg"
                    alt="arrow outward"
                  />
                </div>
              </a>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="d-flex align-items-center g-8 booking-trip-body">
    <div class="w-100">
      <h2 class="semi-bold booking-trip-body-title">Itinerary</h2>

      @if (data) {
        <portal-option-details
          [itineraries]="data.flightItineraries"
          [portalLink]="data.portalLink"
        />
      }
    </div>

    @if (tickets?.length) {
      <div class="w-100">
        <h2 class="semi-bold booking-trip-body-title">Travelers</h2>
        <div class="g-4 d-flex flex-column booking-trip-body-travelers">
          @for (ticket of tickets; track ticket.codeNumber) {
            <traveler-info
              [fields]="travelerFields"
              [additionalFields]="travelerAdditionalFields"
              [data]="ticket"
            >
              <div class="d-flex">
                <p>E-ticket number:&nbsp;</p>
                <p data-id="ticket-number">{{ ticket.codeNumber }}</p>
              </div>
            </traveler-info>
          }
        </div>
      </div>
    }
  </div>
</div>
